var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.937,
    height: 31.709,
    viewBox: "0 0 37.937 31.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(-0.997 -4.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_334",
    "data-name": "Trac\\xE9 334",
    d: "M29.848,12.666a10.131,10.131,0,0,0-19.654-.011A10.144,10.144,0,0,0,11.145,32.9h3.8a1.268,1.268,0,0,0,0-2.536h-3.8A7.608,7.608,0,0,1,11.1,15.146,1.316,1.316,0,0,0,12.5,14.063a7.6,7.6,0,0,1,15.041,0A1.369,1.369,0,0,0,28.9,15.146a7.608,7.608,0,1,1,0,15.216h-3.8a1.268,1.268,0,0,0,0,2.536h3.8a10.144,10.144,0,0,0,.951-20.232Z",
    transform: "translate(0)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_335",
    "data-name": "Trac\\xE9 335",
    d: "M23.051,21.5a1.268,1.268,0,1,0,1.793-1.793l-6.34-6.34a1.268,1.268,0,0,0-1.793,0l-6.34,6.34A1.268,1.268,0,1,0,12.165,21.5l4.175-4.176V33.288a1.268,1.268,0,0,0,2.536,0V17.329Z",
    transform: "translate(2.413 2.146)",
    fill: "#b2b2b2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c95cfd8f7e2468f1c08d5d099904bb17.svg";
export { ForwardRef as ReactComponent };